<template>
  <form
    class="flex flex-wrap bg-white p-3 items-center justify-around text-center safe-refill"
    :class="credits > 0 ? 'bg-select' : ''"
    @submit.prevent="selectCredits(credits)"
  >
    <div class="cost flex items-center w-32">
      <div class="">
        <input
          type="number"
          class="flex"
          v-model.number="amount"
          step="any"
          min="0"
          required
        />
      </div>
      <span class="ml-1">€</span>
    </div>
    <div class="text-center flex justify-around">
      <div
        class="text-white p-2 w-20 rounded font-bold text-sm"
        :class="
          discount > 0 ? 'visible data-level-' + bonus.level : 'invisible'
        "
        v-html="'+' + formatNumber(discount) + '%'"
      ></div>
    </div>
    <div class="credit cost flex items-center w-32">
      <div class="">
        <input
          type="number"
          class=""
          v-model.number="credits"
          step="any"
          min="1"
          required
        />
      </div>
      <span class="ranch-credit ml-1">€</span>
    </div>
    <div
      class="rounded px-1 font-bold py-1 text-white bg-promo-bg"
      v-if="improvedRenderAmount != credits"
    >
      <em class="block text-sm">{{ promotion.i18n.title }}</em>
      <span class="text-promo-fg">
        {{ improvedRenderAmount.toLocaleString(locale) }}
        <span class="ranch-credit ml-1">€</span>
      </span>
    </div>
    <div class="w-12">
      <button
        type="submit"
        class="bg-action px-3 py-1 rounded text-white"
        :class="[
          'data-level-' + (bonus || {}).level,
          credits > 0 ? '' : 'hidden',
        ]"
      >
        <font-awesome-icon icon="arrow-right"></font-awesome-icon>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: ["bonuses", "promotion"],
  data() {
    return {
      amount: 0,

      discount: 0,
      promotionDiscount: 0,
      bonus: null,
    };
  },
  methods: {
    formatNumber(value) {
      return (value / 1).toFixed();
    },

    getCredits() {
      let discount = 0;
      let amount = this.amount;
      for (var i = 0, len = this.reverseBonuses.length; i < len; i++) {
        if (amount >= this.reverseBonuses[i].cost) {
          discount = this.reverseBonuses[i].discount;
          this.bonus = this.reverseBonuses[i];
          break;
        }
      }
      this.discount = discount;

      if (this.discount === 0) {
        this.bonus = null;
      }

      return +(amount * (1 + discount / 100)).toFixed(2);
    },

    setAmount(credits) {
      let discount = 0;
      let amount = parseFloat(credits);
      if (isNaN(amount)) {
        return;
      }

      for (var i = 0, len = this.reverseBonuses.length; i < len; i++) {
        if (credits >= this.reverseBonuses[i].credit) {
          discount = this.reverseBonuses[i].discount;
          amount = credits / (1 + discount / 100);
          break;
        }
      }
      this.discount = discount;
      this.bonus = this.reverseBonuses[i];
      this.amount = +amount.toFixed(2);
    },

    selectCredits(credits) {
      this.$router.push({ name: "invoice.new", query: { credits } });
    },

    discreteBonus(cost, render) {
      const bonus = this.promotion.bonuses[cost] || 0;
      return render + bonus;
    },
    continousPercentBonus(cost, render) {
      const bonus = this.findPercentBonus(cost);
      return Math.round(render * (100 + bonus)) / 100;
    },
    findPercentBonus(cost) {
      const costs = Object.keys(this.promotion.bonuses).reverse();
      const i = costs.find((c) => c <= cost);
      if (!i) {
        return 0;
      }
      return this.promotion.bonuses[i];
    },
  },

  computed: {
    credits: {
      cache: false,
      get() {
        return this.getCredits();
      },
      set(credits) {
        this.setAmount(credits);
      },
    },

    improvedRenderAmount() {
      if (!this.promotion.status) {
        return this.credits;
      }
      if (this.promotion.type === "percentPerCost") {
        return this.continousPercentBonus(this.amount, this.credits);
      }
      return this.discreteBonus(this.amount, this.credits);
    },

    hasPromotion() {
      return this.promotion.status;
    },

    promotionType() {
      return this.promotion.type;
    },

    bonusSuffix() {
      if (this.promotionType === "percentPerCost") {
        return "%";
      }

      if (this.promotionType === "bonusPerCost") {
        return '&nbsp;<span class="ranch-credit">€</span>';
      }
      return "";
    },
    reverseBonuses() {
      return this.bonuses.slice().reverse();
    },

    locale() {
      return this.$route.params.locale || "en";
    },
  },
  watch: {
    $route(r) {
      const initialCredits = +r.query.credits;
      if (initialCredits > 0) {
        this.setAmount(initialCredits);
      }
    },
  },
  mounted() {
    const initialCredits = +this.$route.query.credits;
    if (initialCredits > 0) {
      this.setAmount(initialCredits);
    }
  },
};
</script>
